import './styles.scss';
const CanalFacts = ({
    blockProps = {},
    children
}) => {
    return (
        <div {...blockProps}>
            {children}
        </div>
    );
};

export default CanalFacts;